import { type Grid } from '../../types';

export const getGridStyle = ({ layout }: { layout: Grid }) => {
  return {
    display: 'grid',
    width: '100%',
    gridTemplateColumns: `repeat(${layout.columns}, 1fr)`,
    gridAutoRows: 'minmax(min-content, max-content) 1fr',
  };
};
